import theme from "./theme";
var smallFooter = function smallFooter(props) {
  return theme(props).smallFooter;
};
export var smallFooterBgColor = function smallFooterBgColor(props) {
  return smallFooter(props).backgroundColor;
};
export var smallFooterTextColor = function smallFooterTextColor(props) {
  return smallFooter(props).textColor;
};
export var smallFooterLinkColor = function smallFooterLinkColor(props) {
  return smallFooter(props).linkColor;
};